export class UserFilters {
  username: string;
  firstName: string;
  lastName: string;
  profileUuids: string[];
  email: string;
  phone: string;
  organizationUuids: string[];
  userType: string;
}
